var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 506,
    viewBox: "0 0 480 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1405,
    y: 177.582,
    width: 326,
    height: 322,
    transform: "rotate(-13.923 15.1405 177.582)",
    stroke: "#EBE645",
    strokeWidth: 25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1405,
    y: 93.5821,
    width: 326,
    height: 322,
    transform: "rotate(-13.923 70.1405 93.5821)",
    stroke: "#EBE645",
    strokeWidth: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.01244cce73b460dbd93211033bd4fb56.svg";
export { ForwardRef as ReactComponent };